import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Controparte } from 'src/app/common/models/controparte';
import { Parte } from 'src/app/common/models/parte';
import { CreazionePraticaStoreService } from '../../../services/creazione-pratica-store.service';
import { takeUntil } from 'rxjs/operators';
import { Observable, Subject } from 'rxjs';
import { OperationsService } from 'src/app/core/services/operations.service';

@Component({
  selector: 'step-parti-form-inserimento',
  templateUrl: './step-parti-form-inserimento.component.html',
  styleUrls: ['./step-parti-form-inserimento.component.css']
})
export class StepPartiFormInserimentoComponent implements OnInit {

  currentForm: string;
  form = FORM;
  @Input() parte: Parte;
  @Output() controparteChange: EventEmitter<Controparte> = new EventEmitter<Controparte>();
  @Output() onParteReturn: EventEmitter<Parte> = new EventEmitter<Parte>();
  componentDestroyed$: Subject<void> = new Subject<void>();
  controparti: Controparte[] = [];

  constructor(
    private creazionePraticaStoreService: CreazionePraticaStoreService,
    private operations: OperationsService
  ){

    this.creazionePraticaStoreService.controparti$.pipe(takeUntil(this.componentDestroyed$)).subscribe(controparti => {
      this.controparti = [];
      if(controparti){
        this.controparti = controparti;
      }
    })
  }

  ngOnInit() {
    this.currentForm = (this.parte != null) ? FORM.ASSOCIATIVA : FORM.ANAGRAFICA;
  }

  onEmitAnagrafica(parte: Parte){
    this.parte = parte;
    this.operations.addNewAnagrafica(parte).subscribe(
      response => this.onParteReturn.emit(response.anagrafiche[0] as Parte)
    );
    this.currentForm = FORM.ASSOCIATIVA;
  }

  onEmitAssociativa(event: Controparte){
    this.controparteChange.emit(event);
    this.currentForm = FORM.ANAGRAFICA;
  }

  ngOnDestroy(): void {
    this.componentDestroyed$.next();
  }

}

export enum FORM{
  ANAGRAFICA = 'anagrafica',
  ASSOCIATIVA = 'associativa'
}
